import { useEffect, useState } from 'react'
import { ArrowIcon } from '../../../shared/ui/icons'

const AUTOPLAY_MS = 7000

const manifestoSlides = [
  {
    key: 'product',
    lines: ['Buen producto', 'es apenas el principio.'],
    body: 'La calidad del producto es sólo el comienzo. Todo lo demás también tiene que responder.',
  },
  {
    key: 'business',
    lines: ['Queremos entender', 'el negocio detrás', 'de cada compra.'],
    body: 'Qué necesita cada cliente, cómo opera, qué le preocupa y hacia dónde quiere crecer.',
  },
  {
    key: 'scale',
    lines: ['La escala cambia.', 'Nuestro estándar no.'],
    body: 'Desde una compra personal hasta el suministro recurrente de una empresa.',
  },
  {
    key: 'relationship',
    lines: ['Queremos construir', 'relaciones que nos', 'permitan anticiparnos.'],
    body: 'Encontrar mejores formas de abastecer, resolver problemas y acompañar el crecimiento de nuestros clientes.',
  },
  {
    key: 'standard',
    lines: ['Buen producto es', 'el principio.', 'Todo lo demás también', 'tiene que estar a la altura.'],
    body: 'Queremos ser el proveedor que entiende por qué cada pedido importa.',
  },
]

export function AboutSection() {
  const [activeSlide, setActiveSlide] = useState(0)
  const [isHoverPaused, setIsHoverPaused] = useState(false)
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false)

  const slide = manifestoSlides[activeSlide] ?? manifestoSlides[0]!
  const isPaused = isHoverPaused || prefersReducedMotion

  useEffect(() => {
    const media = window.matchMedia('(prefers-reduced-motion: reduce)')
    const sync = () => setPrefersReducedMotion(media.matches)

    sync()
    media.addEventListener('change', sync)
    return () => media.removeEventListener('change', sync)
  }, [])

  useEffect(() => {
    if (isPaused) return

    const timer = window.setTimeout(() => {
      setActiveSlide((current) => (current + 1) % manifestoSlides.length)
    }, AUTOPLAY_MS)

    return () => window.clearTimeout(timer)
  }, [activeSlide, isPaused])

  const goToSlide = (index: number) => {
    setActiveSlide((index + manifestoSlides.length) % manifestoSlides.length)
  }



  return (
    <section className="about-section" aria-labelledby="about-title">
      <div className="about-section__duet" id="nosotros">
        <div className="about-section__profile">
          <p className="about-section__eyebrow" id="about-title">NOSOTROS</p>

          <div className="about-section__raven" aria-hidden="true">
            <img src="/brand/CuervoBlanco_Cuervo_Cropped_Transparent.svg" alt="" />
          </div>

          <div className="about-section__profile-copy">
            <p className="about-section__identity-lead">
              Somos una empresa mexicana de semillas y alimentos para personas y negocios.
            </p>
            <p>
              En Cuervo Blanco seleccionamos y suministramos productos para quien necesita desde una compra personal hasta una operación recurrente o de mayor volumen.
            </p>
            <p>
              Pero queremos ir más allá de entregar producto. Queremos entender tu negocio como si formáramos parte de él: saber cómo trabajas, qué necesitas y qué podemos hacer para ayudarte a crecer.
            </p>
            <p>
              Combinamos buenos productos, condiciones competitivas, tecnología y logística con algo que para nosotros es indispensable: atención cercana, trato directo y un proveedor que conoce tu negocio, no sólo tu pedido.
            </p>
          </div>
        </div>

        <div className="manifesto" aria-labelledby="manifesto-title">
          <div className="manifesto__frame">
            <div className="manifesto__header">
              <p id="manifesto-title">NUESTRO MANIFIESTO</p>
            </div>

            <div className="manifesto__card">
              <div
                className="manifesto__stage"
              data-slide={slide.key}
              onMouseEnter={() => setIsHoverPaused(true)}
              onMouseLeave={() => setIsHoverPaused(false)}
              onFocusCapture={() => setIsHoverPaused(true)}
              onBlurCapture={() => setIsHoverPaused(false)}
              role="group"
              aria-label={`Manifiesto Cuervo Blanco. Mensaje ${activeSlide + 1} de ${manifestoSlides.length}.`}
            >
              <div className="manifesto__content" key={slide.key}>
                <div className="manifesto__statement">
                  <h3>
                    {slide.lines.map((line) => (
                      <span key={line}>{line}</span>
                    ))}
                  </h3>
                </div>
                <div className="manifesto__support">
                  <p>{slide.body}</p>
                </div>
              </div>

              <div className="manifesto__footer">
                <div className="manifesto__progress" aria-hidden="true">
                  <span
                    className="manifesto__progress-value"
                    style={{ width: `${((activeSlide + 1) / manifestoSlides.length) * 100}%` }}
                  />
                </div>

                <div className="manifesto__controls" aria-label="Controles del manifiesto">
                  <button
                    type="button"
                    className="manifesto__arrow manifesto__arrow--previous"
                    onClick={(event) => {
                      event.stopPropagation()
                      goToSlide(activeSlide - 1)
                    }}
                    aria-label="Mensaje anterior"
                  >
                    <ArrowIcon />
                  </button>

                  <button
                    type="button"
                    className="manifesto__arrow"
                    onClick={(event) => {
                      event.stopPropagation()
                      goToSlide(activeSlide + 1)
                    }}
                    aria-label="Mensaje siguiente"
                  >
                    <ArrowIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  )
}
